<template>
    <div class="tone-talk">
        <h2 v-bind:style="{ color: $a11yInkColor(getCorpHeadingColor) + ' !important'}">Hey, {{user.firstName}}. Great to see you. <br>Enjoy the Tone Talk!</h2>
        <div class="container" v-if="!jwEventRef">
            <div class="row">
                <div class="col-xs-12 col-sm-12 col-md-7">
                    <h3 v-bind:style="{ color: $a11yInkColor(getCorpHeadingColor) + ' !important'}">discussion</h3>
                    <div v-if="getUserSignature">
                        <iframe title="Live event chat" width="100%" height="650" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" allowtransparency="true" :src="chatRollURL"></iframe>
                        <button  class="btn-pink" @click="leaveEvent"><i aria-hidden="true" class="fa fa-sign-out"></i>&nbsp;Leave</button>
                        <!--<iframe width="100%" height="350" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" allowtransparency="true" src="https://chatroll.com/embed/chat/adam-test-11012017?id=QAVZFiECp2J&platform=html&uid=330&uname=Abdul&sig=8c0e653bb27d4157a387b3b71b1b90e7&ismod=0&upic=https://s3.amazonaws.com/tone-assets/images/profile-pictures-new/small/shoes_ked.jpg"></iframe>-->
                    </div>
                    <!--<div class="talkContent">-->
                        <!--<div class="userContent">-->
                            <!--&lt;!&ndash;////////////////////////&ndash;&gt;-->
                            <!--<div class="user">-->
                                <!--<div class="image">-->
                                    <!--<img src="../assets/user-one.png" alt="">-->
                                <!--</div>-->
                                <!--<div class="name">-->
                                    <!--<h6>Stacy <span>4:38 PM</span></h6>-->
                                    <!--<p>Lorem ipsum dolor sit emit.</p>-->
                                <!--</div>-->
                            <!--</div>-->
                            <!--&lt;!&ndash;////////////////////////&ndash;&gt;-->
                            <!--<div class="user">-->
                                <!--<div class="image">-->
                                    <!--<img src="../assets/user-two.png" alt="">-->
                                <!--</div>-->
                                <!--<div class="name">-->
                                    <!--<h6>helen <span>4:38 PM</span></h6>-->
                                    <!--<p>-->
                                        <!--Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris-->
                                        <!--nisi ut aliquip ex ea commodo consequat.-->
                                    <!--</p>-->
                                <!--</div>-->
                            <!--</div>-->
                            <!--&lt;!&ndash;////////////////////////&ndash;&gt;-->
                            <!--<div class="user">-->
                                <!--<div class="image">-->
                                    <!--<img src="../assets/user-three.png" alt="">-->
                                <!--</div>-->
                                <!--<div class="name">-->
                                    <!--<h6>jane <span>4:38 PM</span></h6>-->
                                    <!--<p>-->
                                        <!--Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris-->
                                        <!--nisi ut aliquip ex ea commodo consequat.-->
                                    <!--</p>-->
                                <!--</div>-->
                            <!--</div>-->
                            <!--&lt;!&ndash;////////////////////////&ndash;&gt;-->
                        <!--</div>-->
                        <!--<div class="questionContent">-->
                            <!--<img class="commentIcon" src="../assets/live-question.png" alt="">-->
                            <!--<h3>How do I stay on track with ipsum dolor sit amet, consectetur edipiscing?</h3>-->
                            <!--<img class="arrow" src="../assets/live-event-down-errow.png" alt="">-->
                        <!--</div>-->
                        <!--<div class="talkButton">-->
                            <!--<button type="button">Submit your question</button>-->
                        <!--</div>-->
                    <!--</div>-->
                </div>
                <div class="col-xs-12 col-sm-12 col-md-5">
                    <h3 v-bind:style="{ color: $a11yInkColor(getCorpHeadingColor) + ' !important'}">moderator</h3>
                    <div class="moderatorContent">
<!--                        <img class="userImg" :src="getExpert[0].small_image" :alt="getExpert[0].name" :title="getExpert[0].name">-->
<!--                        <h4>{{getExpert[0].name}}</h4>-->
<!--                        <h5>{{getExpert[0].expertise}}</h5>-->
                        <p>
                            {{getSelectedEvent[0].longDescription}}
                        </p>
                        <h3 v-bind:style="{ color: $a11yInkColor(getCorpHeadingColor) + ' !important'}">attendees</h3>
                        <div class="slider responsive-slick-eventusers" v-if="eventUsersArray">
                        <div class="attendeesImg" *v-for="userList in eventUsersArray">
                            <div class="userImage" v-if="userList[0]">
                                <div v-if="userList[0].isAnonymous === '0'">
                                <img :src="userList[0].picture" alt="USER-SHOE" :title="userList[0].firstName">
                                <span>{{userList[0].firstName}}</span>
                                 </div>
                                <div v-else>
                                    <img :src="userList[0].picture" alt="USER-SHOE" title="Shoe-cognito">
                                    <span>Shoe-cognito</span>
                                    <!--<img class="img-responsive img-circle" src="http://placekitten.com/g/200/200"/>-->
                                    <!--<span>Anonymous</span>-->
                                </div>
                            </div>
                            <div class="userImage" v-if="userList[1]">
                                <div class="userImage" v-if="userList[1]">
                                    <div v-if="userList[1].isAnonymous === '0'">
                                        <img :src="userList[1].picture" alt="USER-SHOE" :title="userList[1].firstName">
                                        <span>{{userList[1].firstName}}</span>
                                    </div>
                                    <div v-else>
                                        <img :src="userList[1].picture" alt="USER-SHOE" title="Shoe-cognito">
                                        <span>Shoe-cognito</span>
                                    </div>
                                </div>
                            </div>
                            <div class="userImage" v-if="userList[2]">
                                <div class="userImage" v-if="userList[2]">
                                    <div v-if="userList[2].isAnonymous === '0'">
                                        <img :src="userList[2].picture" alt="USER-SHOE" :title="userList[2].firstName">
                                        <span>{{userList[2].firstName}}</span>
                                    </div>
                                    <div v-else>
                                        <img :src="userList[2].picture" alt="USER-SHOE" title="Shoe-cognito">
                                        <span>Shoe-cognito</span>
                                    </div>
                                </div>
                            </div>
                            <div class="userImage" v-if="userList[3]">
                                <div class="userImage" v-if="userList[3]">
                                    <div v-if="userList[3].isAnonymous === '0'">
                                        <img :src="userList[3].picture" alt="USER-SHOE" :title="userList[3].firstName">
                                        <span>{{userList[3].firstName}}</span>
                                    </div>
                                    <div v-else>
                                        <img :src="userList[3].picture" alt="USER-SHOE" title="Shoe-cognito">
                                        <span>Shoe-cognito</span>
                                    </div>
                                </div>
                            </div>
                            <div class="userImage" v-if="userList[4]">
                                <div class="userImage" v-if="userList[4]">
                                    <div v-if="userList[4].isAnonymous === '0'">
                                        <img :src="userList[4].picture" alt="USER-SHOE" :title="userList[4].firstName">
                                        <span>{{userList[4].firstName}}</span>
                                    </div>
                                    <div v-else>
                                        <img :src="userList[4].picture" alt="USER-SHOE" title="Shoe-cognito">
                                        <span>Shoe-cognito</span>
                                    </div>
                                </div>
                            </div>
                            <div class="userImage" v-if="userList[5]">
                                <div class="userImage" v-if="userList[5]">
                                    <div v-if="userList[5].isAnonymous === '0'">
                                        <img :src="userList[5].picture" alt="USER-SHOE" :title="userList[5].firstName">
                                        <span>{{userList[5].firstName}}</span>
                                    </div>
                                    <div v-else>
                                        <img :src="userList[5].picture" alt="USER-SHOE" title="Shoe-cognito">
                                        <span>Shoe-cognito</span>
                                    </div>
                                </div>
                            </div>
                            <div class="userImage" v-if="userList[6]">
                                <div class="userImage" v-if="userList[6]">
                                    <div v-if="userList[6].isAnonymous === '0'">
                                        <img :src="userList[6].picture" alt="USER-SHOE" :title="userList[6].firstName">
                                        <span>{{userList[6].firstName}}</span>
                                    </div>
                                    <div v-else>
                                        <img :src="userList[6].picture" alt="USER-SHOE" title="Shoe-cognito">
                                        <span>Shoe-cognito</span>
                                    </div>
                                </div>
                            </div>
                            <div class="userImage" v-if="userList[7]">
                                <div class="userImage" v-if="userList[7]">
                                    <div v-if="userList[7].isAnonymous === '0'">
                                        <img :src="userList[7].picture" alt="USER-SHOE" :title="userList[7].firstName">
                                        <span>{{userList[7].firstName}}</span>
                                    </div>
                                    <div v-else>
                                        <img :src="userList[7].picture" alt="USER-SHOE" title="Shoe-cognito">
                                        <span>Shoe-cognito</span>
                                    </div>
                                </div>
                            </div>
                            <div class="userImage" v-if="userList[8]">
                                <div class="userImage" v-if="userList[8]">
                                    <div v-if="userList[8].isAnonymous === '0'">
                                        <img :src="userList[8].picture" alt="USER-SHOE" :title="userList[7].firstName">
                                        <span>{{userList[8].firstName}}</span>
                                    </div>
                                    <div v-else>
                                        <img :src="userList[8].picture" alt="USER-SHOE" title="Shoe-cognito">
                                        <span>Shoe-cognito</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container" v-else>
            <div class="rowtight">
                <div class="col-sm-7 innerpadding align:top">
                    <div  class="embed-responsive embed-responsive-16by9">
                        <iframe title="TONE video player"  class="embed-responsive-item" :src="jwEventRef" frameborder="0" scrolling="auto" allowfullscreen ></iframe>
                    </div>
                </div>
                <div class="col-sm-5 text-left">
                    <div v-if="getUserSignature">
                        <h4 v-bind:style="{ color: $a11yInkColor(getCorpHeadingColor) + ' !important'}">TONE Talks Coaching: {{getSelectedEvent[0].title}}</h4>
<!--                        <p>Welcome to TONE Talks Career Coaching on TONE Networks! Join us for a discussion on how you can elevate your career. Hello, I'm your host {{getExpert[0].name}} </p>-->
                        <p>Welcome! Join us for a discussion that will inspire and empower you to be the best version of yourself.</p>
                        <h6 v-if="getShowCountFlag">Total Participants: {{participantCount}}</h6>
                        <iframe title="Live event chat" width="100%" height="400px" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" allowtransparency="true" :src="chatRollURL"></iframe>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import $ from 'jquery'
    import slick from 'slick-carousel'
    export default {
        name: 'Talk',
        metaInfo () {
            return {
                title: 'TONE | Talk Event',
                meta: [
                    {property: 'og:image', content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-1.jpg'},
                    {property: 'og:title', content: 'TONE | Talk Event'},
                    {property: 'og:site_name', content: 'TONE Networks | Expert Advice on Demand'},
                    {
                        property: 'og:description',
                        content: 'TONE Networks provides women with resources and support to help them flourish in every aspect of their lives.'
                    },
                    {property: 'twitter:title', content: 'TONE | Talk Event'},
                    {property: 'twitter:card', content: 'summary'},
                    {property: 'twitter:image', content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-1.jpg'},
                    {
                        property: 'twitter:description',
                        content: 'TONE Networks provides women with resources and support to help them flourish in every aspect of their lives.'
                    },
                    {property: 'og:image:width', content: '300'},
                    {property: 'og:image:height', content: '300'}
                ]
            }
        },
        data: function () {
            return {
                showParticipants: false,
                chatRollURL: '',
                eventUsersArray: [],
                eventUserArray: [],
                chatrllRef: '',
                intervalId: '',
                jwEventRef: '',
                participantCount: 0,
                seatReservation: {
                    userEventId: 0,
                    eventId: 0,
                    userId: 0,
                    status: 0,
                    isAnonymous: 0
                }
            }
        },
        methods: {
            setCarousal () {
                $.slick = slick
                const $slick = $(this.$el).find('.responsive-slick-eventusers')
                $slick.each(function () {
                    $slick.slick({
                        dots: false,
                        infinite: false,
                        speed: 300,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        responsive: [{
                            breakpoint: 1024,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 1,
                                infinite: false,
                                dots: false
                            }
                        }, {
                            breakpoint: 600,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1
                            }
                        }, {
                            breakpoint: 480,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1
                            }
                        }]
                    })
                })
            },
            leaveEvent () {
                this.$store.dispatch('GETUSEREVENTS', this.user.userId).then(res => {
                    if (this.getUserEvents) {
                        let uEvent = this.getUserEvents.filter(ev => {
                            // return ev.eventId === this.getSelectedEvent[0].eventId
                            return ev.eventId === this.$route.params.eventId
                        })
                        if (uEvent && uEvent.length > 0) {
                            // this.seatReservation.eventId = this.getSelectedEvent[0].eventId
                            this.seatReservation.eventId = this.$route.params.eventId
                            this.seatReservation.userId = this.user.userId
                            this.seatReservation.status = '1'
                            this.seatReservation.isAnonymous = '0'
                            this.seatReservation.userEventId = uEvent[0].userEventId
                            this.$store.dispatch('UPDATERESERVATION', this.seatReservation).then(res => {
                                this.$store.dispatch('LEAVEEVENT').then(() => {
                                    // this.$router.push('/')
                                })
                            }).catch(err => {
                                console.log('ERROR in UPDATERESERVATION ====> err = ', err)
                            })
                        }
                    }
                }, 300).catch(err => {
                    console.log('inside leaveEvent () : ERROR in -> GETUSEREVENTS  ====> err = ', err)
                })
            },
            refreshAttendees () {
                let self = this
                // console.log('1 inside refreshAttendees () : self.getSelectedEvent = ', self.getSelectedEvent);
                if (self.getSelectedEvent) {
                    // console.log('2 inside refreshAttendees () : self.getSelectedEvent[0].eventId = ', self.getSelectedEvent[0].eventId);
                    // console.log('3 inside refreshAttendees () : self.$route.params.eventId = ', self.$route.params.eventId)
                    // self.$store.dispatch('GETEVENTUSERS', self.getSelectedEvent[0].eventId).then(() => {
                    self.$store.dispatch('GETEVENTUSERS', self.$route.params.eventId).then(res => {
                        if (self.getEventUsers) {
                            if (!self.getSelectedEvent[0].jw_rtmp_url) {
                                // console.log('refreshing regular chat 1')
                                self.participantCount = self.getEventUsers.lstUserEvents.length
                                self.eventUsersArray.splice(0, self.eventUsersArray.length)
                                $(this.$el).find('.responsive-slick-eventusers').slick('unslick')
                                // Divide Users into sub array
                                self.eventUserArray = self.getEventUsers.lstUserEvents
                                // console.log('3.1A -> inside refreshAttendees () -> self.eventUserArray.length = ', self.eventUserArray.length)
                                while (self.eventUserArray.length > 0) {
                                    self.eventUsersArray.push(self.eventUserArray.splice(0, 9))
                                }
                                setTimeout(() => {
                                    self.setCarousal()
                                }, 1000)
                                // Event has ended, need to redirect user
                                if (self.getEventUsers.upcomingEvent) {
                                    self.$swal({
                                        background: '#44bda8',
                                        title: 'This TONE event has ended. Add Next Upcoming Event to Your Calendar',
                                        html: '<span style="color: #fff;padding-top:30px;font-size:24px;">' + self.getEventUsers.upcomingEvent.description + ' </span>',
                                        text: '',
                                        type: null,
                                        timer: 5000,
                                        showConfirmButton: true,
                                        showCloseButton: true,
                                        showCancelButton: false,
                                        confirmButtonColor: '#f0617d',
                                        confirmButtonText:
                                            'Find out more'
                                    }).then(
                                        function () {
                                            self.$router.push('/event')
                                        },
                                        // handling the promise rejection
                                        function (dismiss) {
                                            if (dismiss === 'timer') {
                                                self.$router.push('/event')
                                            }
                                        })
                                }
                            } else {
                                // console.log('4 inside refreshAttendees () : self.getEventUsers.lstUserEvents.length = ', self.getEventUsers.lstUserEvents.length)
                                self.participantCount = self.getEventUsers.lstUserEvents.length
                                // Event has ended, need to redirect user
                                if (self.getEventUsers.upcomingEvent) {
                                    self.$swal({
                                        background: '#44bda8',
                                        title: self.getEventUsers.scheduleUpcomingEventMsg,
                                        html: '<span style="color: #fff;padding-top:30px;font-size:24px;">' + self.getEventUsers.upcomingEvent.description + ' </span>',
                                        text: '',
                                        type: null,
                                        timer: 5000,
                                        showConfirmButton: true,
                                        showCloseButton: true,
                                        showCancelButton: false,
                                        confirmButtonColor: '#f0617d',
                                        confirmButtonText:
                                            'Find out more'
                                    }).then(
                                        function () {
                                            self.$router.push('/event')
                                        },
                                        // handling the promise rejection
                                        function (dismiss) {
                                            if (dismiss === 'timer') {
                                                self.$router.push('/event')
                                            }
                                        })
                                }
                            }
                        }
                    }).catch(err => {
                        console.log('inside refreshAttendees () : ERROR in -> GETEVENTUSERS ====> err = ', err)
                    })
                }
                // console.log('5 inside refreshAttendees () : QUITTING FUNCTION');
            }
        },
        // created() {
        //     console.log('1 -> Talk.vue -> created () -> ')
        //     this.$store.dispatch('GETSELECTEDEVENT', this.$route.params.eventId).then(res => {
        //     }).catch( err => {    // this.$store.dispatch('GETSELECTEDEVENT', this.$route.params.eventId).then(res => {
        //         console.log('1 ERROR in -> GETSELECTEDEVENT  ====> err = ', err);
        //     })
        // },
        mounted () {
            // below "let self = this" line is added on 12/10/2021 during event navigation issue debugging
            let self = this
            console.log('1 -> Talk.vue -> mounted () -> self.getUserSignature', self.getUserSignature)
            // if (this.getUserSignature) {
            if (self.getUserSignature) {
                console.log('1A -> Talk.vue -> mounted () -> self.$route.params.eventId = ', self.$route.params.eventId)
                // if (this.$route.params.eventId > 0) {
                if (self.$route.params.eventId > 0) {
                    console.log('1B -> Talk.vue -> mounted () -> self.$route.params.eventId = ', self.$route.params.eventId)
                    // if (!this.getSelectedEvent) {
                    //     this.$store.dispatch('GETSELECTEDEVENT', this.$route.params.eventId).then(res => {
                    //     }).catch( err => {    // this.$store.dispatch('GETSELECTEDEVENT', this.$route.params.eventId).then(res => {
                    //             console.log('1 ERROR in -> GETSELECTEDEVENT  ====> err = ', err)
                    //     })
                    // }
                    // this.$store.dispatch('GETSELECTEDEVENT', this.$route.params.eventId).then(res => {
                    self.$store.dispatch('GETSELECTEDEVENT', self.$route.params.eventId).then(res => {
                        console.log('2 -> Talk.vue -> mounted () -> ')
                        // if (this.getSelectedEvent) {
                        if (self.getSelectedEvent) {
                            // this.chatrllRef = this.getSelectedEvent.chatroll_event_name
                            self.chatrllRef = self.getSelectedEvent.chatroll_event_name
                            // this.$store.dispatch('GETEXPERT', this.getSelectedEvent[0].expertId).then(() => {
                            // })
                            console.log('3 -> Talk.vue -> mounted () -> self.getSelectedEvent[0].eventId = ', self.getSelectedEvent[0].eventId)
                            console.log('3A -> Talk.vue -> mounted () -> self.$route.params.eventId = ', self.$route.params.eventId)
                            // this.$store.dispatch('GETEVENTUSERS', this.getSelectedEvent[0].eventId).then(() => {
                            // if (!this.getEventUsers) {
                            //     this.$store.dispatch('GETEVENTUSERS', this.$route.params.eventId).then(res => {
                            //     }).catch( err => {    // this.$store.dispatch('GETSELECTEDEVENT', this.$route.params.eventId).then(res => {
                            //         console.log('3 ERROR in -> GETEVENTUSERS  ====> err = ', err);
                            //     })
                            // }
                            // this.$store.dispatch('GETEVENTUSERS', this.$route.params.eventId).then(res => {
                            self.$store.dispatch('GETEVENTUSERS', self.$route.params.eventId).then(res => {
                                // if (this.getEventUsers) {
                                if (self.getEventUsers) {
                                    console.log('4 -> Talk.vue -> mounted () -> self.getEventUsers.lstUserEvents.length = ', self.getEventUsers.lstUserEvents.length)
                                    // this.participantCount = this.getEventUsers.length
                                    self.participantCount = self.getEventUsers.lstUserEvents.length    // self.getEventUsers.length
                                    // Divide Users into sub array
                                    // this.eventUserArray = this.getEventUsers
                                    // self.eventUserArray = self.getEventUsers   // undefined - commented on 12/10/2021
                                    self.eventUserArray = self.getEventUsers.lstUserEvents
                                    // while (this.eventUserArray.length > 0) {
                                    //     this.eventUsersArray.push(this.eventUserArray.splice(0, 9))
                                    // }
                                    console.log('4.1A -> Talk.vue -> mounted () -> self.eventUserArray.length = ', self.eventUserArray.length)
                                    while (self.eventUserArray.length > 0) {
                                        self.eventUsersArray.push(self.eventUserArray.splice(0, 9))
                                    }
                                    console.log('4A -> Talk.vue -> mounted () -> ')
                                    setTimeout(() => {
                                        // this.setCarousal()
                                        self.setCarousal()
                                        window['interval'] = setInterval(() => {
                                            // this.refreshAttendees()
                                            self.refreshAttendees()
                                        }, 30000)
                                    }, 1000)
                                    console.log('4B -> Talk.vue -> mounted () -> ')
                                }
                            }).catch(err => {   // this.$store.dispatch('GETEVENTUSERS', this.$route.params.eventId).then(res => {
                                console.log('4C : ERROR in -> GETEVENTUSERS ====> err = ', err)
                            })
                            console.log('4D -> Talk.vue -> mounted () -> ')
                        } else {
                            console.log('5 -> Talk.vue -> mounted () -> ')
                            // if (this.user && (this.user.corporation && this.user.corporation.enableCorporatePage === 1)) {
                            if (self.user && (self.user.corporation && self.user.corporation.enableCorporatePage === 1)) {
                                console.log('6 -> Talk.vue -> mounted () -> going to /corporation/mycommunity')
                                // this.$router.push(`/corporation/mycommunity`)
                                self.$router.push(`/corporation/mycommunity`)
                            } else {
                                // if (this.user && this.user.adminAccessLevel === 1) {
                                if (self.user && self.user.adminAccessLevel === 1) {
                                    console.log('7 -> Talk.vue -> mounted () -> ')
                                    // this.$router.push(`/event/` + this.$route.params.eventId)
                                    self.$router.push(`/event/` + self.$route.params.eventId)
                                } else {
                                    console.log('8 -> Talk.vue -> mounted () -> ')
                                    // this.$router.push(`/events`)
                                    self.$router.push(`/events`)
                                }
                            }
                        }
                    }).catch(err => {    // this.$store.dispatch('GETSELECTEDEVENT', this.$route.params.eventId).then(res => {
                        console.log('7A ERROR in -> GETSELECTEDEVENT  ====> err = ', err)
                    })
                } else {
                    // if (this.user && (this.user.corporation && this.user.corporation.enableCorporatePage === 1)) {
                    if (self.user && (self.user.corporation && self.user.corporation.enableCorporatePage === 1)) {
                        console.log('9 -> Talk.vue -> mounted () -> ')
                        // this.$router.push(`/corporation/mycommunity`)
                        self.$router.push(`/corporation/mycommunity`)
                    } else {
                        // if (this.user && this.user.adminAccessLevel === 1) {
                        if (self.user && self.user.adminAccessLevel === 1) {
                            console.log('10 -> Talk.vue -> mounted () -> ')
                            // this.$router.push(`/event/` + this.$route.params.eventId)
                            self.$router.push(`/event/` + self.$route.params.eventId)
                        } else {
                            console.log('11 -> Talk.vue -> mounted () -> ')
                            // this.$router.push(`/events`)
                            self.$router.push(`/events`)
                        }
                    }
                }
            } else {
                // if (this.user && (this.user.corporation && this.user.corporation.enableCorporatePage === 1)) {
                //     console.log('12 -> Talk.vue -> mounted () -> ')
                //     this.$router.push(`/corporation/mycommunity`)
                // } else {
                //     if (this.user && this.user.adminAccessLevel === 1) {
                //         console.log('13 -> Talk.vue -> mounted () -> this.$route.params.eventId = ', this.$route.params.eventId)
                //         this.$router.push(`/event/` + this.$route.params.eventId)
                //     } else {
                //         console.log('14 -> Talk.vue -> mounted () -> ')
                //         this.$router.push(`/events`)
                //     }
                // }
                if (self.user && (self.user.corporation && self.user.corporation.enableCorporatePage === 1)) {
                    console.log('12 -> Talk.vue -> mounted () -> ')
                    self.$router.push(`/corporation/mycommunity`)
                } else {
                    if (self.user && self.user.adminAccessLevel === 1) {
                        console.log('13 -> Talk.vue -> mounted () -> self.$route.params.eventId = ', self.$route.params.eventId)
                        self.$router.push(`/event/` + this.$route.params.eventId)
                    } else {
                        console.log('14 -> Talk.vue -> mounted () -> ')
                        self.$router.push(`/events`)
                    }
                }
            }
            // if (this.getSelectedEvent) {
            //     let userPic
            //     if (this.user && (this.user.corporation && this.user.corporation.showShoeMotif === 2)) {
            //         userPic = 'https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/genericProfile-sm.png'
            //     } else {
            //         userPic = this.user.picture
            //     }
            //     if (this.getUserStatus === '0') {
            //         this.chatRollURL = `${this.getSelectedEvent[0].chatroll_event_name}&uid=${this.user.userId}&uname=${this.user.firstName}&sig=${this.getUserSignature}&ismod=0&upic=${userPic}`
            //     } else {
            //         let uName = 'Shoe-cognito'
            //         if (this.user && (this.user.corporation && this.user.corporation.showShoeMotif === 2)) {
            //             uName = 'Incognito'
            //         }
            //         this.chatRollURL = `${this.getSelectedEvent[0].chatroll_event_name}&uid=${this.user.userId}&uname=${uName}&sig=${this.getUserSignature}&ismod=0&upic=${userPic}`
            //     }
            // }
            if (self.getSelectedEvent) {
                let userPic
                if (self.user && (self.user.corporation && self.user.corporation.showShoeMotif === 2)) {
                    userPic = 'https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/genericProfile-sm.png'
                } else {
                    userPic = this.user.picture
                }
                if (self.getUserStatus === '0') {
                    self.chatRollURL = `${self.getSelectedEvent[0].chatroll_event_name}&uid=${self.user.userId}&uname=${self.user.firstName}&sig=${self.getUserSignature}&ismod=0&upic=${userPic}`
                } else {
                    let uName = 'Shoe-cognito'
                    if (self.user && (self.user.corporation && self.user.corporation.showShoeMotif === 2)) {
                        uName = 'Incognito'
                    }
                    self.chatRollURL = `${self.getSelectedEvent[0].chatroll_event_name}&uid=${self.user.userId}&uname=${uName}&sig=${self.getUserSignature}&ismod=0&upic=${userPic}`
                }
            }
            // this.jwEventRef = this.getSelectedEvent[0].jw_rtmp_url
            // console.log('15 -> Talk.vue -> mounted () -> ')
            // this.$store.dispatch('GETUSEREVENTS', this.user.userId).then(() => {}).catch( err => {
            //     console.log('15A ERROR in GETUSEREVENTS ====> err = ', err);
            // })
            self.jwEventRef = self.getSelectedEvent[0].jw_rtmp_url
            console.log('15 -> Talk.vue -> mounted () -> ')
            self.$store.dispatch('GETUSEREVENTS', self.user.userId).then(() => {}).catch(err => {
                console.log('15A ERROR in GETUSEREVENTS ====> err = ', err)
            })
        },
        beforeDestroy () {
            this.leaveEvent()
            clearInterval(window['interval'])
        },
        computed: {
            ...mapGetters([
                'user', 'getExpert', 'getSelectedEvent', 'getUserEvents', 'getEventUsers', 'getUserSignature', 'getUserStatus', 'getShowCountFlag',
                'getCorpHeaderColor', 'getCorpFooterColor', 'getCorpButtonColor', 'getCorpHeadingColor']
            )
        }
    }
</script>

<style scoped>
    .attendeesImg>.userImage span {
        word-wrap: normal;
        white-space: nowrap;
    }
    .btn-pink{
        color: #f0617d;
        border: 1px solid #f0617d;
        background: none;
        outline: none;
        font-size: 16px;
        font-family: sans-serif;
        letter-spacing: 0.3px;
        float: left;
        margin-left: 0px;
        width: 100%;
        padding: 13px 15px 9px;
        border-radius: 3px;
        margin-top: 10px;
        max-width: 100%;
    }
    @media(min-width:768px){
        .innerpadding {
            padding-top: 36px;
        }
    }
</style>



// WEBPACK FOOTER //
// Talk.vue?f3e4a67c